import { render, staticRenderFns } from "./seckill.vue?vue&type=template&id=228d04c9&"
import script from "./seckill.vue?vue&type=script&lang=js&"
export * from "./seckill.vue?vue&type=script&lang=js&"
import style0 from "./seckill.vue?vue&type=style&index=0&id=228d04c9&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('228d04c9')) {
      api.createRecord('228d04c9', component.options)
    } else {
      api.reload('228d04c9', component.options)
    }
    module.hot.accept("./seckill.vue?vue&type=template&id=228d04c9&", function () {
      api.rerender('228d04c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/seckill.vue"
export default component.exports